import 'react-h5-audio-player/lib/styles.css'
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'
import React from 'react'
import { Card } from 'antd'

type Props = {
  audioUrl: string
  className?: string
}

const CustomAudioPlayer: React.FC<Props> = ({ audioUrl, className = '' }) => {
  return (
    <Card className="audio-player-card">
      <div className={`custom-audio-player ${className}`}>
        <AudioPlayer
          src={audioUrl}
          autoPlay={false}
          showJumpControls={false}
          layout="horizontal"
          customControlsSection={[RHAP_UI.VOLUME]}
          customProgressBarSection={[
            RHAP_UI.MAIN_CONTROLS,
            RHAP_UI.CURRENT_TIME,
            RHAP_UI.PROGRESS_BAR,
            RHAP_UI.DURATION
          ]}
        />
      </div>
    </Card>
  )
}

export default CustomAudioPlayer
